export default [
  {
    path: '/campaign/list',
    name: 'campaign-list',
    component: () => import('@/views/pages/document/document-list/DocumentList.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Documents',
      },
      {
        text: 'Campaign List',
        active: true,
      },
    ],
  },
  {
    path: '/campaign/list/document-detail/:ref',
    name: 'campaign-list-document-detail',
    component: () => import('@/views/pages/document/document-list/DocumentDetail.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Documents',
      },
      {
        text: 'Campaign List',
      },
      {
        text: 'Campaign Detail',
        active: true,
      },
    ],
  },
  {
    path: '/campaign/info/:ref',
    name: 'campaign-info',
    component: () => import('@/views/pages/document/document-info/DocumentInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Documents',
      },
      {
        text: 'Campaign List',
      },
      {
        text: 'Campaign Detail',
      },
      {
        text: 'Manage Document Info',
        active: true,
      },
    ],
  },
]
